import { ISSUE_FIELD_SPOTLIGHT_PREFIX } from '@atlassian/jira-issue-view-common-constants/src/view-constants';

export const MAJOR_INCIDENT = 'MAJOR_INCIDENT';
const MAJOR_INCIDENT_FIELD_KEY = 'major-incident-field';
export const SPOTLIGHT_ID = `${ISSUE_FIELD_SPOTLIGHT_PREFIX}${MAJOR_INCIDENT_FIELD_KEY}`;
